/**
 * Small app-wide enums. Only `LoginErrorResponse` has importers; `ActionType`,
 * `UnitOfMeasureType` and `DebouncerPlusEvents` are left from product quantity and
 * unit-of-measure controls this app no longer has, and have no importer in this repo.
 */

/** Quantity stepper direction. No importer in this repo. */
export enum ActionType {
	INCREMENT = "increment",
	DECREMENT = "decrement",
}

/** Which unit-of-measure picker a change came from: quantity or price. No importer in this repo. */
export enum UnitOfMeasureType {
	QUANTITY = "quantityUom",
	PRICE = "priceUom",
}
/** Input events a debounced field reacts to. No importer in this repo. */
export enum DebouncerPlusEvents {
	focus = "focus",
	change = "change",
}
//TODO Need to go into common
/**
 * The sign-in error strings the Users API returns as the response body of a failed sign-in.
 *
 * Contract with `web-users-api/application/src/enums/user.ts` → `MageniumVerifyAccountError`,
 * whose values come from Magenium. `ContactSupport` (HTTP 423, account locked) shows
 * `components/Shared/Password/LockOutErrorMessage.tsx`, and `Reset` (HTTP 403) shows
 * `ResetErrorMessage.tsx`, in `components/Login/LoginHelpers/Login.Components.tsx` →
 * `ErrorMessage`. `components/ForgotPassword/ResetPassword/ResetPassword.tsx` shows the lock-out
 * message for `ContactSupport` too. The values must match the API's text exactly; nothing reads
 * `Invalid` here.
 */
export enum LoginErrorResponse {
	Invalid = "Invalid",
	ContactSupport = "Contact Support",
	Reset = "Reset",
}
